export const APP_CONFIG = {
  SEARCH_MIN_CHARS: 4,
  DEBOUNCE_TIME: 300,
  SESSION_TIMEOUT_MINUTES: 30,
  MAX_CELULAR_LENGTH: 15,
  MIN_CELULAR_LENGTH: 8,
  ARGENTINA_COUNTRY_CODE: "549",
  DELAY_BETWEEN_REQUESTS: 200,
} as const;

export const PORTAL_INFO = {
  NAME: "Centro Ginecológico Allende Pinto",
  PWA_APP_NAME: "Portal de Paciente Centro Ginecológico Allende Pinto",
  PWA_SHORT_NAME: "Portal CGAP",
  IOS_DISMISS_KEY: "iosModalDismissedCentroGinecologicoAllendePinto",
} as const;

export const COLORS = {
  SUCCESS: "verde",
  ERROR: "rojo",
  WARNING: "amarillo",
  INFO: "azul",
} as const;

export const DATE_FORMATS = {
  DISPLAY: "DD/MM/YYYY",
  API: "YYYY/MM/DD",
  API_WITH_TIME: "YYYY/MM/DD HH:mm",
  DISPLAY_LONG: "dddd DD de MMMM, YYYY",
} as const;

export const TURNO_ESTADOS = {
  LIBRE: "libre",
  OCUPADO: "ocupado",
  CANCELADO: "cancelado",
  ATENDIDO: "atendido",
  ASISTIO: "asistio",
} as const;
